import React from "react";
import { Button, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { ProductInterface } from "../../types/common.types";
import { useTranslation } from "../../hooks/useTranslation";

const Card = styled(Box)(() => ({
  height: "112px",
  width: "112px",
  padding: "4px",
  border: "1px solid rgba(131, 60, 65, 0.24)",
  background: "#0f0b0b",
  borderRadius: "8px",
  overflow: "hidden",
}));

interface Props {
  isMobile: boolean;
  activeProduct?: ProductInterface;
  action?: () => void;
  showMediaPicker?: (value: boolean) => void;
}

const Photo = (props: Props) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        border: "1px solid rgba(131, 60, 65, 0.16)",
        borderRadius: "8px",
        bgcolor: "rgba(31, 22, 21, 0.72)",
        p: 1.25,
      }}
    >
      <Content {...props} />
    </Box>
  );
};

const Content = (props: Props) => {
  const { showMediaPicker } = props;
  const { selectedMedia, selectedFilePreview } = useSelector(
    (state: RootState) => state.Product
  );

  const photoSelectInfo = useTranslation("photo_select_info");
  const pickAPhoto = useTranslation("pick_a_photo");

  const isActive = !!props.activeProduct?.productPhoto.secureUrl;
  const askToUploadPhoto = !selectedMedia.photo && !selectedFilePreview;

  if (!isActive && askToUploadPhoto) {
    if (props.isMobile && props.action) {
      return <PickPhotoButton action={props.action} text={pickAPhoto} />;
    } else {
      return (
        <Typography sx={{ p: 1, color: "#f87171", fontSize: "12px" }}>
          {`${photoSelectInfo}.`}
        </Typography>
      );
    }
  }

  if (selectedFilePreview) {
    return (
      <Card>
        <img
          src={String(selectedFilePreview)}
          alt="product"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            cursor: "pointer",
            borderRadius: "6px",
          }}
          onClick={showMediaPicker && (() => showMediaPicker(true))}
        />
      </Card>
    );
  }

  return (
    <Card>
      {isActive && props.activeProduct && !selectedMedia.photo && (
        <img
          src={props.activeProduct.productPhoto.secureUrl}
          alt="product"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            cursor: "pointer",
            borderRadius: "6px",
          }}
          onClick={showMediaPicker && (() => showMediaPicker(true))}
        />
      )}

      {isActive && selectedMedia.photo && (
        <img
          src={selectedMedia.photo}
          alt="product"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            cursor: "pointer",
            borderRadius: "6px",
          }}
          onClick={showMediaPicker && (() => showMediaPicker(true))}
        />
      )}

      {!isActive && (
        <img
          src={selectedMedia.photo}
          alt="product"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "6px",
          }}
        />
      )}
      {props.isMobile && props.action && (
        <PickPhotoButton action={props.action} text={pickAPhoto} />
      )}
    </Card>
  );
};

interface ButtonProps {
  action: () => void;
  text: string;
  color?: "error" | "primary";
}

export const PickPhotoButton = (props: ButtonProps) => {
  const btnColor = props.color ? props.color : "error";

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        margin: "10px 0",
      }}
    >
      <Button variant="contained" color={btnColor} onClick={props.action}>
        {props.text}
      </Button>
    </Box>
  );
};

export default Photo;
